import { render, staticRenderFns } from "./EditorWrap.vue?vue&type=template&id=1ea823ae&scoped=true&"
import script from "./EditorWrap.vue?vue&type=script&lang=js&"
export * from "./EditorWrap.vue?vue&type=script&lang=js&"
import style0 from "./EditorWrap.vue?vue&type=style&index=0&id=1ea823ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea823ae",
  null
  
)

component.options.__file = "EditorWrap.vue"
export default component.exports